import { PaginationData } from 'shared/types';
import request from '../../features/service-providers/services/requesters/service-provider.request';
import { Contact } from 'shared/models';

const contactService = {
  getContacts: (params: any) =>
    request.get<PaginationData<Contact>>('/contacts', { params }),
  findContact: (contactId: number, params: any) =>
    request.get(`/contacts/${contactId}`, { params }),
  createContact: (data: any) => request.post<Contact>('/contacts', data),
  updateContact: (contactId: number, data: any) =>
    request.put<Contact>(`/contacts/${contactId}`, data),
  deleteContact: (contactId: number) =>
    request.delete(`/contacts/${contactId}`),
};

export default contactService;
